<template>
    <price-change-history />
</template>

<script>
import PriceChangeHistory from '@/components/PriceChangeHistory.vue'
export default {
    components: {
        PriceChangeHistory
    }
}
</script>
